import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from 'material-ui/Typography';
import Title from '../common/Title';
import moment from 'moment';

const styles = () => ({
  root: {
    background: '#F4F6F9',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    padding: '25px 25px 20px 25px',
    boxSizing: 'border-box',
  },

  empty: {
    padding: '12px',
    fontSize: '13px',
  },

  tip: {
    width: 0,
    height: 0,
    borderLeft: '25px solid transparent',
    borderRight: '25px solid transparent',
    borderTop: '15px solid #F4F6F9',
    position: 'absolute',
    left: 'calc(50% - 10px)',
  },
});

class KeymanBiographies extends React.Component {
  render () {
    const { classes, item } = this.props;

    return (
      <div>
        <div className={classes.root}>
          <Title title="経歴" color="light" style={{ marginTop: '0px'}} />
          {(() => {
            if (item && item.executive_biographies && item.executive_biographies.length > 0) {
              return item.executive_biographies.map((e, i) => (
                <Typography variant="body2" key={i} style={{ color: 'inherit', marginTop: '5px'}}>
                {`${moment(e.relocation_at).format('YYYY年MM月')} ${e.content}`}
                </Typography>
              ))
            } else {
              return (
                <div className={classes.empty} style={{ marginTop: '-10px'}}>
                  情報が見つかりませんでした
                </div>
              )
            }
          })()}
        </div>
        <div className={classes.tip} />
      </div>
    );
  }
}

KeymanBiographies.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
}

PropTypes.defaultValue = {}

export default withStyles(styles)(KeymanBiographies);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/sections/KeymanBiographies.jsx